import { Option, Select } from '@shared/components';
import { useToast } from '@shared/components/toast';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import {
  MeDocument,
  PluginLandingPage,
  useUpdateUserSettingsMutation,
} from '@shared/generated/graphql';

const LANDING_PAGE_LABELS: Record<PluginLandingPage, string> = {
  [PluginLandingPage.CHATS]: 'Chats',
  [PluginLandingPage.ACTIVITY]: 'Activity',
};

export function LandingPageSelect({ className }: { className?: string }) {
  const { me } = useMeContext();
  const { sendToast } = useToast();
  const [updateUserSettings, { loading }] = useUpdateUserSettingsMutation();

  const landingPage =
    me?.settings?.pluginLandingPage ?? PluginLandingPage.CHATS;

  const saveLandingPage = async (pluginLandingPage: PluginLandingPage) => {
    if (!me?.id) return;
    try {
      await updateUserSettings({
        variables: { input: { id: me.id, settings: { pluginLandingPage } } },
        refetchQueries: [MeDocument],
      });
    } catch (error) {
      sendToast("Couldn't save your start page", {
        variant: 'error',
        description: error instanceof Error ? error.message : undefined,
      });
    }
  };

  return (
    <Select
      className={className}
      value={landingPage}
      isDisabled={loading}
      renderValue={(page) => LANDING_PAGE_LABELS[page]}
      onChange={saveLandingPage}
    >
      {[PluginLandingPage.CHATS, PluginLandingPage.ACTIVITY].map((page) => (
        <Option key={page} value={page}>
          {LANDING_PAGE_LABELS[page]}
        </Option>
      ))}
    </Select>
  );
}
